module.exports = __webpack_public_path__ + "img/2_131.16a5695e.png";